var _style, _g, _line, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .venting-st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:currentColor;stroke-width:9.9997;stroke-miterlimit:15.1178;}\r\n        .venting-st1{fill:none;stroke:currentColor;stroke-width:9.9999;stroke-miterlimit:15.118;}\r\n        .venting-st2{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:currentColor;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:15.1178;}\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect77",
    x: 67.7,
    y: 69,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -75.4604 180.3029)",
    className: "venting-st0",
    width: 224.5,
    height: 224.5
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "venting-st1",
    x1: 73.2,
    y1: 125.8,
    x2: 231.9,
    y2: 284.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "venting-st2",
    d: "M107.6,202.6c3.6-13.2,9.6-21.6,15.3-27.1c18-17.3,39.2-11.8,55-29.1c7.4-8.1,10.5-17.8,11.9-26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "venting-st2",
    d: "M133.5,227.6c3.6-13.2,9.6-21.6,15.3-27.1c18-17.3,39.2-11.8,55-29.1c7.4-8.1,10.5-17.8,11.9-26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "venting-st2",
    d: "M158.4,252.7c3.6-13.2,9.6-21.6,15.3-27.1c18-17.3,39.2-11.8,55-29.1c7.4-8.1,10.5-17.8,11.9-26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenting);
export default __webpack_public_path__ + "static/media/venting.57298fe1fd384f8fa78c15cb517c66b2.svg";
export { ForwardRef as ReactComponent };